export default __webpack_public_path__ + "static/media/Body_C4.514d7996.svg";